// Strip trailing slashes to prevent double-slash issues (e.g., localhost:8000//graph)
export const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
const rawWebUrl = process.env.REACT_APP_WEB_URL || 'http://localhost:3000/';
export const WEB_URL = rawWebUrl.endsWith('/') ? rawWebUrl : `${rawWebUrl}/`;
export const AUTH_DOMAIN = (process.env.REACT_APP_AUTH_DOMAIN || '').replace(/^https?:\/\//, '');
export const APP_VERSION = process.env.REACT_APP_VERSION || process.env.npm_package_version || '0.1.0';
